import React from 'react';
import _ from 'lodash';

const SingleLegendLabel = ({ label, width = 200, index, data, render, addSemicolon }) => {
  let value = _.get(data, index);

  if (!!render) {
    value = render(value, data);
  }

  return (
    <div>
        <strong className={ `text-muted summary-label-text width-${width}` }>{ label }{ addSemicolon && ':'}</strong>
        { value }
    </div>
  )
}

export const renderLegends = (data, options = { addSemicolon: true }) => (item) => {
  return (
    <SingleLegendLabel
      key={ item.index }
      label={ item.label }
      index={ item.index }
      data={ data }
      render={ item.render }
      { ...options }
    />
  )
}


export default SingleLegendLabel;